export default {
  buildingComplexes: [],
  buildingComplexesList: [],
  filters: {},
  paginationOptions: {}
};
